module.exports = __webpack_public_path__ + "assets/img/glbanner.14a20d22.png";